
const match = {
  // Match Details
  match: {
    backToLeague: "Back to League",
    notFound: "Match not found",
    dateNotAvailable: "Date not available",
    matchEvents: "Match Events",
    summary: "Match Summary",
    referee: "Referee",
    stadium: "Stadium",
    city: "City",
    round: "Round",
    status: "Status",
    date: "Date",
    competition: "Competition",
    tabs: {
      info: "Info",
      statistics: "Statistics", 
      h2h: "H2H",
      predictions: "Predictions",
      lineups: "Lineups"
    },
    events: {
      goal: "Goal",
      yellowCard: "Yellow Card",
      redCard: "Red Card",
      substitutedBy: "substituted by"
    }
  }
};

export default match;
